<template>
  <div>
    <van-nav-bar title="我的" />
    <van-cell-group class="user-group">
      <!-- icon="infos" title="个人信息" -->
      <van-cell>
        <!-- is-link to="myinfo"  -->
        <van-row>
          <van-col span="10"
            ><van-image
              style="margin-left: 10px;"
              round
              width="2rem"
              height="2rem"
              fit="contain"
              :src="headimgurl"
          /></van-col>
          <van-col span="14">
            <van-row type="flex">
              <h3>{{ name }}</h3>
            </van-row>
            <van-row type="flex">
              <h5>工作证号：{{ workid }}</h5>
            </van-row>
            <van-row type="flex">
              <h5>现有积分：{{ points }}</h5>
            </van-row>
            <van-row type="flex">
              <h5>共累积积分：{{ pride }}</h5>
            </van-row>
          </van-col>
        </van-row>
      </van-cell>
    </van-cell-group>

    <van-cell-group class="user-group">
      <van-cell is-link to="myactivity">
        <template slot="icon">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-huodong"></use>
          </svg>
        </template>
        <template slot="title">
          <span class="custom-title">可报名活动</span>
        </template>
      </van-cell>
      <van-cell is-link to="myenrolledactivity/enrolled">
        <template slot="icon">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-huodongyingxiao"></use>
          </svg>
        </template>
        <template slot="title">
          <span class="custom-title">我已报名活动</span>
        </template>
      </van-cell>
      <van-cell is-link to="myenrolledactivity/attended">
        <template slot="icon">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-huodong1"></use>
          </svg>
        </template>
        <template slot="title">
          <span class="custom-title">我已参加活动</span>
        </template>
      </van-cell>
    </van-cell-group>

    <van-cell-group>
      <van-cell is-link to="mypointshistory">
        <template slot="icon">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-jifen"></use>
          </svg>
        </template>
        <template slot="title">
          <span class="custom-title">我的积分历史</span>
        </template>
      </van-cell>
      <van-cell is-link to="myexchangeproducts">
        <template slot="icon">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-lipin"></use>
          </svg>
        </template>
        <template slot="title">
          <span class="custom-title">我兑换的商品</span>
        </template>
      </van-cell>
    </van-cell-group>

    <van-cell-group class="user-group">
      <van-cell is-link to="mysuggestion">
        <template slot="icon">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-yijianfankui"></use>
          </svg>
        </template>
        <template slot="title">
          <span class="custom-title">我的意见建议</span>
        </template>
      </van-cell>
    </van-cell-group>

    <van-cell-group class = "user-group">
      <van-cell  @click = "clearStorage">
        <template slot="icon">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-tuichu"></use>
          </svg>
        </template>
        <template slot="title">
          <span class="custom-title">退出登录</span>
        </template>
      </van-cell>
    </van-cell-group>
    <mTabbar></mTabbar>
  </div>
</template>

<script>
import mTabbar from '../components/TabBar'
import store from '../store'
import $ from "jquery"
import { Row, Col, Icon, Cell, CellGroup } from 'vant';

export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    mTabbar
  },
  data() {
    return {
      name: this.$store.state.name,
      headimgurl: this.$store.state.headimgurl,
      workid: this.$store.state.workid,
      points: this.$store.state.points,
      pride: this.$store.state.pride,
      // department: this.$store.state.department,
      // personid: this.$store.state.personid,
      // phone: this.$store.state.phone,
      // cardid: this.$store.state.cardid
    };
  },
  created: function () {
    this.getContent();
  },
  methods: {
    getContent: function () {
      let APIBASEURL = "https://www.gongdiangonghui.cn";
      const _this = this;
      $.ajax({
        cache: false,
        contentType: "application/json",
        dataType: "json",
        type: "POST",
        url: APIBASEURL + "/member/getSelfInfo",
        data: JSON.stringify({
          jwt: store.state.jwt
        }),
        async: false,
        // beforeSend: function (XMLHttpRequest) {
        //				XMLHttpRequest.setRequestHeader("authorization", storage["yuekejwt"]);
        //			},
        error: function (request) {
          alert("发送请求失败" + JSON.stringify(request));
        },
        success: function (response) {
          // alert("成功，response是:" + JSON.stringify(response));
          // {"contentType":0,"contentid":4,"createtime":"2020-03-06 15:31:02","id":13,"image":"http://cdn.learningpartner.club/trade/common/1/e75c4044-ac65-428e-a8a3-d942a8f478b3","isForIndex":true,"sort":9,"title":"测试多个文章2","type":"测试"}
          if (response.code != "200") {
            if (response.msg == "no user info related weixin") {
              _this.$router.push('/registry');
            } else {
              alert("返回错误信息" + response.msg);
            }
          } else {
            // alert("成功，response是:" + JSON.stringify(response.data));
            _this.name = response.data.name;
            _this.headimgurl = response.data.headimgurl;
            _this.points = response.data.points;
            _this.pride = response.data.pride;
            _this.workid = response.data.workid;
            store.commit('setname', response.data.name);
            store.commit('setheadimgurl', response.data.headimgurl);
            store.commit('setworkid', response.data.workid);
            store.commit('setdepartment', response.data.department);
            store.commit('setpersonid', response.data.personid);
            store.commit('setphone', response.data.phone);
            store.commit('setpoints', response.data.points);
            store.commit('setpride', response.data.pride);
            store.commit('setcardid', response.data.cardid);
          }
        },
      });
    },
    clearStorage: function(){
      alert("退出登录，重新注册");
      localStorage.clear();
      store.commit('clearStorage');
      this.$router.push('/');
    },

  }
};
</script>

<style lang="less" scoped>
h5 {
  color: gray;
}
.icon {
  width: 1.6em;
  height: 1.6em;
  margin-left: 10%;
}
.van-cell__title {
  text-align: left;
  padding-left: 25%;
}

.user {
  &-poster {
    width: 100%;
    height: 53vw;
    display: block;
  }

  &-group {
    margin-bottom: 15px;
  }

  &-links {
    padding: 15px 0;
    font-size: 12px;
    text-align: center;
    background-color: #fff;

    .van-icon {
      display: block;
      font-size: 24px;
    }
  }
}
</style>